export default __webpack_public_path__ + "static/210512_更新完成_en-50d49a09c3f234a1de3421cd302a1abb.webp";